import React from "react";
import { BtnContainer, Container, InfoContainer } from "./NoshowListItemSkeleton.styles";
import UI from "@mile-meeting/mile-ui";

const NoshowListItemSkeleton: React.FC = () => {
  return (
    <Container>
      <InfoContainer>
        <UI.Loading.Skeleton width="100%" height="25px" />
        <UI.Loading.Skeleton width="100%" height="22px" />
      </InfoContainer>
      <UI.Loading.Skeleton width="140px" height="22px" />
      <UI.Loading.Skeleton width="120px" height="22px" />
      <UI.Loading.Skeleton width="100px" height="22px" />
      <BtnContainer>
        <UI.Loading.Skeleton width="115px" height="32px" />
        <UI.Loading.Skeleton width="115px" height="32px" />
      </BtnContainer>
    </Container>
  );
};

export default React.memo(NoshowListItemSkeleton);
